import { PayloadAction } from '@reduxjs/toolkit';
import { DesignState } from 'src/store/design/types';

const setIncludeDpiEnhancementReducer = (state: DesignState, action: PayloadAction<boolean>) => {
  state.includeDpiEnhancement = action.payload;
};

export default setIncludeDpiEnhancementReducer;
